import { render, staticRenderFns } from "./event-management-register.vue?vue&type=template&id=fbd582d4&scoped=true&"
import script from "./event-management-register.vue?vue&type=script&lang=js&"
export * from "./event-management-register.vue?vue&type=script&lang=js&"
import style0 from "./event-management-register.vue?vue&type=style&index=0&lang=css&"
import style1 from "./event-management-register.vue?vue&type=style&index=1&id=fbd582d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbd582d4",
  null
  
)

export default component.exports